import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'

import GoogleSlidesAddOnNotSupportedContainer from 'containers/paywalls/addon_not_supported/google_slides_addon_not_supported_container'
import styles from './google_slides_addon_not_supported_route.scss'

class AddOnNotSupportedRoute extends PureComponent {

	render() {
		return (
			<div styleName='wrapper'>
				<GoogleSlidesAddOnNotSupportedContainer />
			</div>
		)
	}
}

export default CSSModules(AddOnNotSupportedRoute, styles, {allowMultiple: true})
